/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';

//helpers
import { sleep } from '@/helpers/sleep';

//screen
import { ManagedTransportation } from '@/screens/ManagedTransportation';

function getSearchVal() {
  if (typeof window === 'undefined') {
    return null;
  }
  const currentSearch = window.location.search;
  return currentSearch;
}

export default function ManagedTransportationPage() {
  const router = useRouter();

  /**
   * Handle the temporary redirect set on Hubspot: https://app.hubspot.com/settings/5041527/domains/url-redirects
   * For the LP: http://lp.loadsmart.com/en/free-transportation-cost-savings-assessment
   */
  const handleFormJump = async () => {
    await sleep(300);
    router.push('/shipper/managed-transportation/#hubspot-form');
  };

  useEffect(() => {
    const searchParams = getSearchVal();
    if (searchParams.length > 0 && searchParams.includes('form=true')) {
      handleFormJump();
    }
  }, []);

  return (
    <>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        canonical="https://loadsmart.com/shipper/managed-transportation/"
        openGraph={{
          url: 'https://loadsmart.com/shipper/managed-transportation/',
        }}
        title="Managed Transportation Services and Logistics Consulting | Loadsmart"
        description="Discover efficient and cost-effective managed transportation services tailored to your business needs. Freight management services & expertise powered by ShipperGuide TMS."
      />
      <ManagedTransportation />
    </>
  );
}
